// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { viewSelectStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListViewSelect";
import Grid from "@insite/mobius/Icons/Grid";
import List from "@insite/mobius/Icons/List";
import Table from "@insite/mobius/Icons/Table";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

viewSelectStyles.listViewClickable = {
    css: css`
        margin-right: 15px;
    `,
};

viewSelectStyles.listViewIcon = {
    src: List,
    size: 22,
};

viewSelectStyles.gridViewClickable = {
    css: css`
        margin-right: 15px;
    `,
};

viewSelectStyles.gridViewIcon = {
    src: Grid,
    size: 22,
};

viewSelectStyles.tableViewIcon = {
    src: Table,
    size: 18,
};

viewSelectStyles.selectLabel = {
    size: 14,
    css: css`
        margin-right: 5px;
    `,
};

viewSelectStyles.listViewWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

viewSelectStyles.gridViewWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

viewSelectStyles.tableViewWrapper = {
    css: css`
        display: flex;
        align-items: center;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css``,
                css``,
                css``,
            ]);
        }}
    `,
};
